export default __webpack_public_path__ + "static/media/Poppins-Light.9bec05ab.woff2";